module.exports = __webpack_public_path__ + "static/assets/a54e98269f78b67e2036168fced9b070.svg";